module.exports = __webpack_public_path__ + "media/belltone.ff3ed4e6.mp3";